import type { ArtifactKind } from '@/services/artifact-vocabulary';
import type { PAST_VIDEOS_TAB } from '@/features/past-videos/links';

/**
 * The Artifacts page's tabs, with no icons and no zod (the address validator in the entry chunk reads them). Four
 * kinds have instances; influencer review batches and reports are placeholders ("Coming soon").
 */
export const PLACEHOLDER_KINDS = ['influencer_batch', 'report'] as const;
export type PlaceholderKind = (typeof PLACEHOLDER_KINDS)[number];
/** Past videos (lane 3, 16 Oct 2026): a list of its own, added for a role with Content (`features/past-videos/tab-search.ts`). */
export type PastVideosTab = typeof PAST_VIDEOS_TAB;
/** Scheduled tasks (Draper's operator agent, 24 Oct 2026): what Draper does on a schedule for her, a list of its own (`features/scheduled-tasks`). */
export const SCHEDULED_TASKS_TAB = 'scheduled_tasks';
export type ScheduledTasksTab = typeof SCHEDULED_TASKS_TAB;
/** Documents (25 Oct 2026): her team's reference documents, a list of its own (`features/documents`). */
export const DOCUMENTS_TAB = 'documents';
export type DocumentsTab = typeof DOCUMENTS_TAB;
/** Analyses (26 Oct 2026): what Watson researched for the brand, a list of its own (`features/analyses`). */
export const ANALYSES_TAB = 'analyses';
export type AnalysesTab = typeof ANALYSES_TAB;
/** Scout's searches (26 Oct 2026): each standing search Scout runs, and what it found (`features/scouts`). */
export const SCOUTS_TAB = 'scouts';
export type ScoutsTab = typeof SCOUTS_TAB;
/** The team's agents (Draper v2, 28 Oct 2026): named teammates who own a job, a list of their own (`features/agents`). */
export const AGENTS_TAB = 'agents';
export type AgentsTab = typeof AGENTS_TAB;
/** The tabs of Draper v2's own lists (not artifacts of the managed read): each has its own cards and count. */
export type OwnListTab = ScheduledTasksTab | DocumentsTab | AnalysesTab | ScoutsTab | AgentsTab;
export type ArtifactTab = 'all' | ArtifactKind | PlaceholderKind | PastVideosTab | OwnListTab;

/** The page's tabs, in order. */
export const ARTIFACT_TABS: readonly Exclude<ArtifactTab, PastVideosTab>[] = ['all', 'brand_deal', 'deliverable', 'contract', 'negotiation', 'influencer_batch', 'report'];
